import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
export function CerebroComparison() {
  const rows = [{
    sit: 'Buscás un archivo',
    sin: '15 minutos de caos',
    con: '10 segundos'
  }, {
    sit: 'Llega el cierre de trimestre',
    sin: 'Datos dispersos en todos lados',
    con: 'Ficha digital de cada alumno lista'
  }, {
    sit: 'Te piden estadísticas hoy',
    sin: 'Releer todo de cero',
    con: 'Template listo en 3 minutos'
  }, {
    sit: 'Querés reusar material del año pasado',
    sin: 'No encontrás nada',
    con: 'Archivo de Legado organizado'
  }];
  return <section className="py-10 px-6 max-w-5xl mx-auto" data-id="element-48">
      <div className="text-center mb-6" data-id="element-49">
        <h3 className="text-2xl md:text-3xl font-bold text-white" data-id="element-50">
          ¿Qué agrega el Cerebro Digital Docente?
        </h3>
      </div>

      {/* Desktop Table */}
      <div className="hidden md:block bg-petroleo rounded-2xl overflow-hidden border border-petroleoLight" data-id="element-51">
        <table className="w-full text-left" data-id="element-52">
          <thead data-id="element-53">
            <tr className="bg-nocheLight border-b border-petroleoLight" data-id="element-54">
              <th className="p-6 text-white font-semibold" data-id="element-55">Situación</th>
              <th className="p-6 text-gray-300 font-semibold flex items-center gap-2" data-id="element-56">
                <X className="w-5 h-5 text-red-400" data-id="element-57" /> Sin él
              </th>
              <th className="p-6 text-white font-semibold bg-tealBrand/10" data-id="element-58">
                <div className="flex items-center gap-2" data-id="element-59">
                  <Check className="w-5 h-5 text-tealBrand" data-id="element-60" /> Con él
                </div>
              </th>
            </tr>
          </thead>
          <tbody data-id="element-61">
            {rows.map((row, idx) => <tr key={idx} className="border-b border-petroleoLight last:border-0" data-id="element-62">
                <td className="p-6 text-gray-200 font-medium" data-id="element-63">{row.sit}</td>
                <td className="p-6 text-gray-400" data-id="element-64">{row.sin}</td>
                <td className="p-6 text-tealBrand font-semibold bg-tealBrand/5" data-id="element-65">
                  {row.con}
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>

      {/* Mobile Cards */}
      <div className="md:hidden space-y-4" data-id="element-66">
        {rows.map((row, idx) => <div key={idx} className="bg-petroleo rounded-xl p-5 border border-petroleoLight" data-id="element-67">
            <div className="font-semibold text-white mb-4 pb-2 border-b border-petroleoLight" data-id="element-68">
              {row.sit}
            </div>
            <div className="space-y-3" data-id="element-69">
              <div className="flex items-start gap-3" data-id="element-70">
                <X className="w-5 h-5 text-red-400 shrink-0 mt-0.5" data-id="element-71" />
                <span className="text-gray-400 text-sm" data-id="element-72">{row.sin}</span>
              </div>
              <div className="flex items-start gap-3" data-id="element-73">
                <Check className="w-5 h-5 text-tealBrand shrink-0 mt-0.5" data-id="element-74" />
                <span className="text-tealBrand font-medium text-sm" data-id="element-75">
                  {row.con}
                </span>
              </div>
            </div>
          </div>)}
      </div>
    </section>;
}